
<div class="container">
    <div class="row justify-content-center">
        <div class="box col-12 col-sm-8 col-lg-6 col-xl-5">
            <div class="box__cont">
                <div [ngClass]= 'isNotValidInputs? "" : "box__title--otp"' class="box__title">
                    <h1>OTP Authentication</h1>
                    <h2>We have sent a One-Time Password (OTP) to your mobile number. Please enter the OTP below to verify your phone number.</h2>
                    <h2>{{mobileNo}}</h2>
                    <h3 class="box__error-notif" *ngIf="isNotValidInputs">The input fields are incomplete.</h3>
                </div>
                <div class="box__form">
                    <div [class.error]="isError" class="col-12 box__field box__field--otp">
                        <ng-otp-input (onInputChange)="onOtpChange($event)"
                                      [config]="{length:6,
                                                allowNumbersOnly: true,
                                                inputClass:'red',
                                                containerClass:'f-form_input'}">
                        </ng-otp-input>
                    </div>
                    <div *ngIf="isInvalidCode" class="col-12 box__field box__field--otp text-center">
                        <h3 class="box__error-notif">Invalid Code</h3>
                    </div>
                    <div *ngIf="!resendOTP" class="col-12 box__field box__field--otp text-center">
                        <p>Request a new code in</p>
                        <span>{{ countDownTracker }} </span>
                    </div>
                    <div *ngIf="resendOTP" class="col-12 box__field box__field--otp text-center">
                        <p>Didn't get code?</p>
                        <p class="resend-otp" (click)="resendOTPCode()">Resend code via SMS</p>
                    </div>
                    <div class="row justify-content-center">
                        <div class="d-sm-none col-12">
                            <div class="buttons buttons--dual">
                                <div class="row">
                                    <div class="buttons__first col-12 col-sm-6">
                                        <atram-button label="Confirm"
                                            componentClass="btn-submit"
                                            (on-click)="proceed()">
                                        </atram-button>  
                                    </div>
                                    <div class="col-12 col-sm-6">
                                        <atram-button buttonType="default"
                                            label="Mobile Register"
                                            componentClass="btn-submit"
                                            (on-click)="goToVerifyNo()">
                                        </atram-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-none d-sm-block col-12">
                            <div class="buttons buttons--dual">
                                <div class="row">
                                    <div class="buttons__first col-12 col-sm-6">
                                        <atram-button buttonType="default"
                                            label="Mobile Register"
                                            componentClass="btn-submit"
                                            (on-click)="goToVerifyNo()">
                                        </atram-button>
                                    </div>
                                    <div class="col-12 col-sm-6">
                                        <atram-button label="Confirm"
                                            componentClass="btn-submit"
                                            (on-click)="proceed()">
                                        </atram-button>  
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<atram-modal #atramModal></atram-modal>
